import styledComp from 'styled-components';
import { TableRow } from '@mui/material';

const minWidth = 1000;

export const StyledTableRowHeader = styledComp(TableRow)`
  /* Jobs Header */
  .actionStatus {
    @media only screen and (min-width: ${minWidth}px) {
      width: 135px;
    }
  }
  .action {
    @media only screen and (min-width: ${minWidth}px) {
      width: 100px;
    }
  }
  .user {
    @media only screen and (min-width: ${minWidth}px) {
      width: 100px;
    }
  }
  .time {
    width: 100px;
  }
  .progress {
    @media only screen and (min-width: ${minWidth}px) {
      width: 165px;
    }
  }
  .machine {
    @media only screen and (min-width: ${minWidth}px) {
      width: 140px;
    }
  }
  .exchangeSport {
    @media only screen and (min-width: ${minWidth}px) {
      width: 160px;
    }
  }
  .actionButtons {
    @media only screen and (min-width: ${minWidth}px) {
      width: 140px;
    }
  }
  .actionButtons.exchange {
    @media only screen and (min-width:${minWidth}px) {
      width: 140px;
    }
  }
  /* Live Events Header */
  .streamStatus {
    @media only screen and (min-width: ${minWidth}px) {
      width: 80px;
    }
  }
  .duration {
    @media only screen and (min-width: ${minWidth}px) {
      width: 100px;
    }
  }
  .securityProfiles {
    @media only screen and (min-width: ${minWidth}px) {
      width: 200px;
    }
  }
  .start {
    @media only screen and (min-width: ${minWidth}px) {
      width: 200px;
    }
  }
  .clip {
    width: 60px;
    text-align: center;
  }
  .liveActions {
    width: 75px;
    text-align: center;
  }
`;
